<div *ngIf="loaded && dataGroupItem.dataTable[0]?.data.length"
  contextAware
  [ngClass]="[dataGroupItem.dataClassName ?? '']"
  [rowIndex]="0"
  [dataItem]="dataGroupItem.dataTable[0].data[row]">
  <div class="b-t-line"></div>
  <app-sketch-fab [modelId]="dataGroupItem.dataTable[0].data[row].contentJSON.modelId"></app-sketch-fab>
</div>

